var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ShippingFast component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconShippingFast extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.19043 2.68994C3.77622 2.68994 3.44043 3.02573 3.44043 3.43994C3.44043 3.85415 3.77622 4.18994 4.19043 4.18994H7.47043C7.88464 4.18994 8.22043 3.85415 8.22043 3.43994C8.22043 3.02573 7.88464 2.68994 7.47043 2.68994H4.19043ZM9.82031 4.47998C9.82031 4.06577 10.1561 3.72998 10.5703 3.72998H12.8103C14.1145 3.72998 15.1703 4.78577 15.1703 6.08998V6.95996H19.2599C21.4526 6.95996 23.2399 8.73424 23.2399 10.94V17.39C23.2399 17.8042 22.9041 18.14 22.4899 18.14H20.794C20.6232 19.9542 19.0995 21.37 17.2399 21.37C15.3792 21.37 13.8546 19.9524 13.6855 18.1364C13.6607 18.1389 13.6355 18.1401 13.6101 18.1401H9.90434C9.7335 19.9543 8.20974 21.37 6.35027 21.37C4.4908 21.37 2.96705 19.9543 2.79621 18.1401H1.91992C1.50571 18.1401 1.16992 17.8043 1.16992 17.3901C1.16992 16.9759 1.50571 16.6401 1.91992 16.6401H2.97231C3.45291 15.2367 4.78223 14.23 6.35027 14.23C7.91832 14.23 9.24764 15.2367 9.72824 16.6401H13.6101C13.6304 16.6401 13.6504 16.6409 13.6703 16.6425V7.73441C13.6701 7.72629 13.6699 7.71814 13.6699 7.70996C13.6699 7.70178 13.6701 7.69363 13.6703 7.68551V6.08998C13.6703 5.61419 13.2861 5.22998 12.8103 5.22998H10.5703C10.1561 5.22998 9.82031 4.89419 9.82031 4.47998ZM15.1703 14.8892C15.7538 14.474 16.4679 14.23 17.2399 14.23C18.8079 14.23 20.1372 15.2366 20.6178 16.64H21.7399V10.94C21.7399 9.56569 20.6272 8.45996 19.2599 8.45996H15.1703V14.8892ZM15.1699 17.8C15.1699 16.6542 16.0941 15.73 17.2399 15.73C18.3857 15.73 19.3099 16.6542 19.3099 17.8C19.3099 18.9458 18.3857 19.87 17.2399 19.87C16.0941 19.87 15.1699 18.9458 15.1699 17.8ZM6.35027 15.73C5.20449 15.73 4.28027 16.6542 4.28027 17.8C4.28027 18.9458 5.20449 19.87 6.35027 19.87C7.49606 19.87 8.42027 18.9458 8.42027 17.8C8.42027 16.6542 7.49606 15.73 6.35027 15.73ZM1.9502 7.18994C1.9502 6.77573 2.28598 6.43994 2.7002 6.43994H6.5702C6.98441 6.43994 7.3202 6.77573 7.3202 7.18994C7.3202 7.60416 6.98441 7.93994 6.5702 7.93994H2.7002C2.28598 7.93994 1.9502 7.60416 1.9502 7.18994ZM1.07031 10.1899C0.656099 10.1899 0.320312 10.5257 0.320312 10.9399C0.320312 11.3542 0.656099 11.6899 1.07031 11.6899H6.10031C6.51453 11.6899 6.85031 11.3542 6.85031 10.9399C6.85031 10.5257 6.51453 10.1899 6.10031 10.1899H1.07031Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconShippingFast.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconShippingFast.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconShippingFast.prototype, "size", void 0);
if (customElements.get('cat-icon-shipping-fast') === undefined) {
    customElements.define('cat-icon-shipping-fast', BlocksIconShippingFast);
}
